import { BaseApi } from "./base.api";
import { TLeadIconConfig } from "types/lead-icon.type";
import { LeadIcon } from "enums/lead-icon.enum";

export class AccountLeadIconsApi extends BaseApi {
  async fetchAccountLeadIcons(accountId: number): Promise<TLeadIconConfig[]> {
    return this.get(`/accounts/${accountId}/lead-icons`);
  }

  async createAccountLeadIcon(
    accountId: number,
    data: { source: string; type: string; icon: LeadIcon }
  ): Promise<TLeadIconConfig> {
    return this.post(`/accounts/${accountId}/lead-icons`, data);
  }

  async updateAccountLeadIcon(
    accountId: number,
    leadIconId: number,
    data: { icon: LeadIcon }
  ): Promise<TLeadIconConfig> {
    return this.put(`/accounts/${accountId}/lead-icons/${leadIconId}`, data);
  }

  async deleteAccountLeadIcon(
    accountId: number,
    leadIconId: number
  ): Promise<void> {
    return this.del(`/accounts/${accountId}/lead-icons/${leadIconId}`);
  }
}
